module.exports = __webpack_public_path__ + "img/RJC_LP_nachhaltigkeit@2x.2937149.webp";